export const MAX_LOGOS_LIMIT = 50;
